namespace Ir.Components.General.IntroButton {

    interface IViewModel {
        buttonConfig: DevExpress.ui.dxButton.Properties;
    }
    export interface IParams {
        introId: string;
    }

    export function getViewModel(this: IViewModel, params: IParams, componentInfo) {
        let self = this;
        let intro = IntroService.intros.find(intro => intro.id === params.introId);
        self.buttonConfig = {
            icon: 'ms ir-live-help-icon',
            hint: "Show the intro tour for " + intro.name,
            stylingMode: 'text',
            elementAttr: {
                class: "intro-help-button",
            },
            onClick() {
                intro.show(true);
            },
        }
    }
}